import { generateKlerpOrderPdf } from "./klerpOrderPdfShared";

const createQuotation = async (original) => {
    try {
        await generateKlerpOrderPdf(original, {
            referenceLabel: "QUOTATION ID:",
            showPaymentBreakdown: false,
            downloadFileName: `Quotation-${original.invoiceId}-${original.userId.name}`,
        });
    } catch (err) {
        alert("Failed");
        console.log(err);
    }
};

export default createQuotation;
